import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from 'src/environments/environment';
import { Prescription } from '../Models/prescription.model';

@Injectable({
  providedIn: 'root',
})
export class PrescriptionService {
  url = environment.Url + 'Prescriptions';
  prescriptionDrugUrl = environment.Url + 'Prescriptions/prescriptionDrugs';
  GivenUrl = environment.Url + 'Prescriptions/givenStatus';

  header = new HttpHeaders({
    Authorization: 'token' + localStorage.getItem('token'),
  });

  constructor(private http: HttpClient) {}

  registerPrescription(body) {
    return this.http
      .post<Prescription>(this.url, body)
      .pipe(catchError(this.handleError));
  }

  saveMultiplePrescriptions(body: Prescription[]) {
    return this.http
      .post<Prescription[]>(this.url + '/saveMultiplePrescriptions', body)
      .pipe(catchError(this.handleError));
  }

  getPrescriptions() {
    return this.http
      .get<Prescription[]>(this.url)
      .pipe(catchError(this.handleError));
  }
  getPrescriptionById(id) {
    return this.http.get<Prescription>(this.url + '/' + id);
  }

  getPrescriptionDrugs(id) {
    return this.http.get<Prescription>(this.prescriptionDrugUrl + '/' + id);
  }

  updatePrescription(id, body) {
    return this.http
      .put<Prescription>(this.url + '/' + id, body)
      .pipe(catchError(this.handleError));
  }

  deletePrescription(id) {
    return this.http
      .delete<Prescription>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error);
        return throwError(error.error);
      } else if (error.status == 401) {
        return throwError('invalid Prescription');
      } else if (error.status == 0) {
        return throwError('network failure please try again later ');
      }
      return throwError(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
